
import React, { useEffect, useState } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { getBookings, declineBooking } from '../api/bookings';
import Datatable from './Datatable';

export default function Bookings() {
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await getBookings('all');
      if (res && res.success) {
        // Ensure newest first (backend should already sort but enforce here too)
        const data = res.data || [];
        data.sort((a, b) => new Date(b.createdAt || b._id?.getTimestamp?.() || b.pickup_date) - new Date(a.createdAt || a._id?.getTimestamp?.() || a.pickup_date));
        // Ensure each row has an `id` prop for selection handling in Datatable
        const withId = data.map((d) => ({ id: d._id || d.booking_reference || Math.random().toString(36).slice(2), ...d }));
        setBookings(withId);
      } else {
        setBookings([]);
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, []);

  const handleDecline = async (bookingRef) => {
    if (!window.confirm(`Decline booking ${bookingRef}?`)) return;
    try {
      const res = await declineBooking(bookingRef);
      console.log('Decline response:', res);
      if (res.success) {
        alert('Booking declined');
        load();
      } else {
        alert('Failed: ' + (res.error || 'unknown'));
      }
    } catch (e) {
      console.error(e);
      alert('Request failed');
    }
  };

  // Datatable columns config (adapted to Datatable component props)
  const columns = [
    { key: 'name', label: 'Name' },
    { key: 'phone', label: 'Phone' },
    { key: 'booking_reference', label: 'Ref' },
    { key: 'vehicle_choice', label: 'Vehicle' },
    { key: 'pickup_date', label: 'Pickup' },
    { key: 'return_date', label: 'Return' },
    { key: 'status', label: 'Status' },
    {
      key: 'actions',
      label: 'Actions',
      render: (row) =>
        row.status === 'confirmed' ? (
          <Button size="small" color="error" variant="outlined" onClick={() => handleDecline(row.booking_reference)}>
            Decline
          </Button>
        ) : null,
    },
  ];
  console.log('Bookings render', bookings, loading);

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Box sx={{ display: 'flex', gap: 2, mb: 2, alignItems: 'center', justifyContent: 'center', width: '100%' }}>
        <Button onClick={load} disabled={loading}>Refresh</Button>
      </Box>
      <Box sx={{ width: '100%' }}>
        <Datatable
          TableData={bookings}
          columns={columns}
          isRetrieved={!loading}
          headingDataOnTable={<Typography variant="h6">Bookings</Typography>}
          pagination={true}
          isSearchBar={true}
          myClass="bookings-table"
        />
      </Box>
    </Box>
  );
}
